const regex = /\*(\S(.*?\S)?)\*/gm;

const formatText = text => {
  return text.replace(regex, "<span>$1</span>");
};

export default formatText;
